import * as FiIcons from "react-icons/fi";
// import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";
import { IconType } from "react-icons";

export interface AvailableIcon {
  name: string;
  component: IconType;
}

// Helper function to convert icon objects to AvailableIcon[]
const mapIcons = (icons: Record<string, IconType>): AvailableIcon[] =>
  Object.entries(icons).map(([name, component]) => ({
    name,
    component,
  }));

export const availableIcons: AvailableIcon[] = [
  ...mapIcons(FiIcons),
  // ...mapIcons(FaIcons),
  ...mapIcons(MdIcons),
];
